import {FrontRoomApi} from '../api-clients';
import { wrap } from '../wrap';


export const expoUserApi = {
  createCustomer: wrap(FrontRoomApi, FrontRoomApi.prototype.createExpoCustomer),
  createSalesman: wrap(FrontRoomApi, FrontRoomApi.prototype.createExpoSalesman),
};